export function clone(v) {
  return typeof structuredClone === 'function'
    ? structuredClone(v)
    : JSON.parse(JSON.stringify(v))
}

export function toBool(v) {
  if (typeof v === 'string') {
    const s = v.trim().toLowerCase()
    if (s === 'true') return true
    if (s === 'false') return false
  }
  return !!v
}

export function toMs(v) {
  let n = v
  if (typeof n === 'string') n = n.trim() === '' ? 0 : Number(n)
  n = Number(n) || 0
  if (!Number.isFinite(n) || n < 0) n = 0
  return Math.round(n / 50) * 50
}

export function toU64(v) {
  let n = v
  if (typeof n === 'string') n = n.trim() === '' ? 0 : Number(n)
  n = Number(n) || 0
  if (!Number.isFinite(n) || n < 0) n = 0
  return Math.floor(n)
}

export function normEnabledDisabled(v, fallback = 'enabled') {
  const s = String(v ?? fallback).trim().toLowerCase()
  return (s === 'disabled') ? 'disabled' : 'enabled'
}

export function normNonNegInt(v, fallback = 0) {
  let n = v
  if (typeof n === 'string') n = n.trim() === '' ? fallback : Number(n)
  n = Number(n)
  if (!Number.isFinite(n) || n < 0) n = fallback
  return Math.floor(n)
}
